import { MonitoringScope } from '../monitoringScope';
import { JVDError, hash, isEmpty } from './functions';
import {
  MONITORING_CAPTUREHADERS,
  MONITORING_CURRENTUSER,
  MONITORING_ERROR,
  MONITORING_EVENT,
  MONITORING_KEY_ACTIONAPI,
  MONITORING_KEY_ACTIONNAME,
  MONITORING_KEY_AUDITORY,
  MONITORING_KEY_ORIGINREPORT,
  MONITORING_KEY_PRODUCT,
  MONITORING_KEY_TRACEID,
  MONITORING_KEY_VERSION,
  MONITORING_KEY_COTIZATION,
  MONITORING_META,
  MONITORING_NOMAIL,
  MONITORING_PAGE,
  MONITORING_REPORT_MESSAGE,
  MONITORING_TERMINATESESSION,
  MONITORING_USER,
  MONITORING_KEY_ACTIONCOMPONENT,
  MONITORING_KEY_USER,
  MONITORING_KEY_PHONE,
  MONITORING_KEY_PLATE,
  MONITORING_KEY_EMAIL,
  MONITORING_KEY_USERTAG,
} from './constants';

export function callMonitoring(...theArgs) {
  if (theArgs) {
    window.ineum?.(...theArgs);
  }
}

export function saveMetaAuditory(auditoryId) {
  callMonitoring(
    MONITORING_META,
    MONITORING_KEY_AUDITORY,
    String(auditoryId || ''),
  );
}

export class Monitoring {
  static startMonitoring({
    version,
    product,
    exit = true,
    removeUser = true,
  }) {
    callMonitoring(MONITORING_META, MONITORING_KEY_VERSION, version);
    callMonitoring(MONITORING_META, MONITORING_KEY_PRODUCT, product);
    function confirmExit() {
      Monitoring.terminateSession(removeUser);
    }
    if (exit) {
      window.onbeforeunload = confirmExit;
    }
  }

  static startSession({
    docNumber,
    names,
    mail,
    phone,
    plate,
    cookieKey,
    digitalId,
  }) {
    sessionStorage.removeItem(MONITORING_CURRENTUSER);
    sessionStorage.setItem(
      MONITORING_CURRENTUSER,
      JSON.stringify({
        user: digitalId,
        name: names,
        email: mail,
      }),
    );

    callMonitoring(MONITORING_CAPTUREHADERS, [
      /.*/i,
      // /content-type/i,
      // /x-amzn-trace-id/i,
      // /X-Amzn-Trace-Id/i,
    ]);

    callMonitoring(MONITORING_USER, digitalId, names, mail || MONITORING_NOMAIL);
    callMonitoring(MONITORING_META, MONITORING_KEY_USER, hash(docNumber, cookieKey));
    callMonitoring(MONITORING_META, MONITORING_KEY_USERTAG, MonitoringScope.get(MonitoringScope.USER_DIGITAL_ID));
    callMonitoring(MONITORING_META, MONITORING_KEY_PHONE, hash(phone, cookieKey));
    callMonitoring(MONITORING_META, MONITORING_KEY_PLATE, hash(plate, cookieKey));
    callMonitoring(MONITORING_META, MONITORING_KEY_EMAIL, hash(mail, cookieKey));
  }

  static startCotization({ idecotizacion }) {
    callMonitoring(MONITORING_META, MONITORING_KEY_USERTAG, MonitoringScope.get(MonitoringScope.USER_DIGITAL_ID));
    callMonitoring(MONITORING_META, MONITORING_KEY_COTIZATION, idecotizacion);
  }

  static terminateSession(removeUser = true) {
    callMonitoring(MONITORING_META, MONITORING_KEY_USERTAG, MonitoringScope.get(MonitoringScope.USER_DIGITAL_ID));
    callMonitoring(MONITORING_TERMINATESESSION);
    if (removeUser) {
      sessionStorage.removeItem(MONITORING_CURRENTUSER);
    }
  }

  static startPage({ stepName, auditoryId }) {
    callMonitoring(MONITORING_META, MONITORING_KEY_USERTAG, MonitoringScope.get(MonitoringScope.USER_DIGITAL_ID));
    callMonitoring(MONITORING_PAGE, stepName);
    saveMetaAuditory(auditoryId);
  }

  static startReport({
    actionComponent,
    actionName,
    actionApi,
    auditoryId,
    origin,
  }) {
    const startTime = Date.now();
    saveMetaAuditory(auditoryId);
    callMonitoring(MONITORING_META, MONITORING_KEY_USERTAG, MonitoringScope.get(MonitoringScope.USER_DIGITAL_ID));
    callMonitoring(MONITORING_META, MONITORING_KEY_ACTIONCOMPONENT, actionComponent);
    callMonitoring(MONITORING_META, MONITORING_KEY_ACTIONNAME, actionName);
    callMonitoring(MONITORING_META, MONITORING_KEY_ACTIONAPI, actionApi);
    callMonitoring(MONITORING_META, MONITORING_KEY_ORIGINREPORT, origin);

    return {
      endReport: (traceId) => {
        if (traceId) {
          callMonitoring(MONITORING_META, MONITORING_KEY_TRACEID, traceId);
        }

        callMonitoring(MONITORING_EVENT, actionName, {
          duration: Date.now() - startTime,
          componentStack: actionComponent,
          meta: {
            [MONITORING_KEY_USERTAG]: MonitoringScope.get(MonitoringScope.USER_DIGITAL_ID),
            originReport: origin,
            actionApi,
            actionName,
            actionComponent,
            auditoryId: String(auditoryId || ''),
            ...(traceId ? { traceId } : {}),
          },
        });
        callMonitoring(MONITORING_META, MONITORING_KEY_ACTIONCOMPONENT, '');
        callMonitoring(MONITORING_META, MONITORING_KEY_ACTIONNAME, '');
        callMonitoring(MONITORING_META, MONITORING_KEY_ACTIONAPI, '');
        callMonitoring(MONITORING_META, MONITORING_KEY_ORIGINREPORT, '');
        callMonitoring(MONITORING_META, MONITORING_KEY_TRACEID, '');
      },
    };
  }

  static reportError({
    origin,
    auditoryId,
    customError,
    traceId,
    actionName = '',
    actionComponent = '',
    actionApi = '',
    actionUrl = '',
    errorString = '',
    customMessage = MONITORING_REPORT_MESSAGE,
    ...generateMetadata
  }) {
    if (!isEmpty(customError)) {
      const myError = new JVDError(
        customError?.error?.message,
        customError?.error?.code,
        customError,
      );
      saveMetaAuditory(auditoryId);
      callMonitoring(MONITORING_ERROR, myError, {
        componentStack: `${customMessage} ${actionComponent}`,
        meta: {
          [MONITORING_KEY_USERTAG]: MonitoringScope.get(MonitoringScope.USER_DIGITAL_ID),
          originReport: origin,
          actionApi,
          actionName,
          actionUrl,
          actionComponent,
          auditoryId: String(auditoryId || ''),
          errorCode: customError?.error?.code,
          errorMessage: customError?.error?.message,
          errorSelector: customError?.selector,
          errorString,
          ...(traceId ? { traceId } : {}),
          ...generateMetadata,
        },
      });
    }
  }
}
